import api from '../services/api';

export interface IssueWorkDTO {
  batch_id?: number | null;
  design_no: string;
  garment_part: string;
  size: string;
  quantity: number;
  worker_id: string;
  press_rate: number;
  notes?: string;
  add_sample_qty?: boolean;
}

export interface ReceiveWorkDTO {
  quantity_received: number;
  defect_quantity: number;
  repair_type_id?: number | null;
  repair_notes?: string;
  notes?: string;
}

export interface ManualJobDTO {
  design_no: string;
  garment_part: string;
  size: string;
  quantity: number;
  worker_id: string;
  press_rate: number;
}

export interface UpdateAssignmentDTO {
  worker_id?: string;
  quantity_issued?: number;
  press_rate?: number;
  issue_date?: string;
  notes?: string;
}

export interface UpdateReceiveDTO {
  quantity_received?: number;
  defect_quantity?: number;
  receive_date?: string;
  notes?: string;
}

export const pressApi = {
  // Get pending press work (from production batches)
  getPendingWork: async (params?: { received_from?: string }) => {
    const response = await api.get('/press/pending-work', { params });
    return response.data;
  },

  // Issue press work to a worker
  issueWork: async (data: IssueWorkDTO) => {
    const response = await api.post('/press/issue', data);
    return response.data;
  },

  // Receive press work from worker
  receiveWork: async (assignmentId: number, data: ReceiveWorkDTO) => {
    const response = await api.post(`/press/receive/${assignmentId}`, data);
    return response.data;
  },

  // Create manual press job
  createManualJob: async (data: ManualJobDTO) => {
    const response = await api.post('/press/manual-job', data);
    return response.data;
  },

  // Get manual press jobs
  getManualJobs: async () => {
    const response = await api.get('/press/manual-jobs');
    return response.data;
  },

  // Update press assignment (edit worker, quantity, rate, date)
  updateAssignment: async (assignmentId: number, data: UpdateAssignmentDTO) => {
    const response = await api.put(`/press/assignment/${assignmentId}`, data);
    return response.data;
  },

  // Update receive record (edit received quantity, date, defects)
  updateReceive: async (receiveId: number, data: UpdateReceiveDTO) => {
    const response = await api.put(`/press/receive/${receiveId}`, data);
    return response.data;
  },

  // Get worker report (worker-wise issued/received summary)
  getWorkerReport: async (params?: { from_date?: string; to_date?: string }) => {
    const response = await api.get('/press/worker-report', { params });
    return response.data;
  },

  // Get worker report detail (assignment-level rows for a specific worker)
  getWorkerReportDetail: async (workerId: string, params?: { from_date?: string; to_date?: string }) => {
    const response = await api.get(`/press/worker-report/${workerId}`, { params });
    return response.data;
  }
};

